module.exports = __webpack_public_path__ + "img/零食3.fba702cf.png";